import gql from 'graphql-tag'
import { USER_FIELDS } from '../course/gql/fragments'
import { LOCATION_DRAWING_FIELDS } from './fragments'
import { PAGE_INFO_FIELDS } from '@/views/Project/gql/fragments'

export const PROJECT_USERS_QUERY = gql`
    query searchProjectUsers($projectId: ID!, $searchTerm: String, $userId: ID, $after: String) {
        projectUsers(
            filter: {
                project: $projectId
                searchTerm: $searchTerm
                user: $userId
                userKindsIfConfirmed: [NORMAL]
            }
            first: 25
            after: $after
            sort: { key: NAME, order: ASC }
        ) {
            nodes {
                displayContractorId
                id
                jobDescription
                jobTitle
                name
                projectId
                displayContractor {
                    companyId
                    id
                    isApproved
                    isArchived
                    namePath
                    projectId
                }
                ... on ConfirmedProjectUser {
                    displayContractorId
                    id
                    jobDescription
                    jobTitle
                    name
                    projectId
                    userId
                    user {
                        ...UserFields
                    }
                    aggregateCourseCompletionData {
                        courseId
                        status
                    }
                }
                ... on PendingProjectUser {
                    displayContractorId
                    email
                    id
                    jobDescription
                    jobTitle
                    name
                    projectId
                }
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
    ${USER_FIELDS}
    ${PAGE_INFO_FIELDS}
`

// LocationDrawing
export const ALLOWED_LOCATION_DRAWING_EXTENSIONS_QUERY = gql`
    query allowedLocationDrawingExtensions {
        allowedLocationDrawingExtensions
    }
`

export const PROJECT_LOCATION_DRAWINGS_QUERY = gql`
    query searchLocationDrawings($projectId: ID!, $after: String, $isArchived: Boolean) {
        locationDrawings(
            filter: { project: $projectId, isArchived: $isArchived }
            first: 25
            after: $after
            sort: { key: CREATED_AT, order: ASC }
        ) {
            nodes {
                ...LocationDrawingFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
    ${LOCATION_DRAWING_FIELDS}
    ${PAGE_INFO_FIELDS}
`
